var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrantyIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.532 14.857c-5.041 0-9.144 4.103-9.144 9.145 0 5.041 4.103 9.144 9.144 9.144 5.042 0 9.145-4.103 9.145-9.144 0-5.043-4.103-9.144-9.145-9.144zm4.798 7.1-5.137 5.137a.739.739 0 0 1-1.046 0l-3.412-3.412a.74.74 0 0 1 1.046-1.046l2.889 2.889 4.614-4.615a.74.74 0 0 1 1.046 1.046z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.515 9.613c-11.225-.148-16.392-3.641-17.982-5-1.59 1.357-6.758 4.852-17.982 5v13.725c-.03.682-.465 15.96 17.982 22.355C42.981 39.298 42.545 24.02 42.515 23.37V9.613zM24.533 34.626c-5.858 0-10.623-4.766-10.623-10.622 0-5.859 4.765-10.623 10.623-10.623 5.859 0 10.623 4.764 10.623 10.623 0 5.858-4.764 10.622-10.623 10.622z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyIcon1);
export default __webpack_public_path__ + "static/media/warrantyIcon1.2a2b2ea46c796475aec2922098a3f1ea.svg";
export { ForwardRef as ReactComponent };